"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var core_1 = require("@material-ui/core");

var hashColor = require("hash-color-material");

var Tags = function (_super) {
  __extends(Tags, _super);

  function Tags() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Tags.prototype.render = function () {
    var tags = this.props.tags;

    if (!tags || tags.length === 0) {
      return null;
    }

    return react_1.default.createElement(react_1.default.Fragment, null, tags.map(function (tag, k) {
      return react_1.default.createElement(core_1.Chip, {
        key: tag.name,
        label: tag.name,
        style: {
          backgroundColor: hashColor.getColorFromString(tag.name, false)
        }
      });
    }));
  };

  return Tags;
}(react_1.Component);

exports.default = Tags;